import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import { FormattedMessage, FormattedHTMLMessage } from 'react-intl';
import { openModal } from '../../actions/modals';
import { publicRequest } from '../../services/ApiService';
import AuthMethodsBlock from '../Auth/AuthMethodsBlock';
import AffiliateEmailSignUpForm from '../Auth/AffiliateEmailSignUpForm';

class AffiliateSignUpModal extends Component {
  state = {
    socials: null,
    isLoading: false,
  };

  componentDidMount() {
    publicRequest
      .getSettings()
      .then((response) => {
        if (response && response.items) {
          const { socials } = response.items;
          this.setState(() => ({ socials }));
        }
      })
      .catch(({ response }) => {
        console.log(response);
      });
  }

  setLoadingState = (bool) => {
    this.setState(() => ({
      isLoading: bool,
    }));
  };

  render() {
    const { socials } = this.state;
    const { closeModal, openModal } = this.props;

    return (
      <div className="auth-modal">
        <div className="auth-modal-innner">
          <button type="button" className="popup-close" onClick={closeModal}>
            <i className="icon-cross-rounded" />
          </button>
          <h2 className="auth-modal-title">
            <FormattedMessage
              id="affiliate.register.title"
              defaultMessage="Registering an Affiliate"
            />
          </h2>
          <AffiliateEmailSignUpForm
            socials={socials}
            openModal={openModal}
            setLoadingState={this.setLoadingState}
          />
          {/* <div className="grecaptcha-disclaimer">
            This site is protected by reCAPTCHA and the Google{' '}
            <a target="_blank" href="https://policies.google.com/privacy">
              Privacy Policy
            </a>{' '}
            and{' '}
            <a target="_blank" href="https://policies.google.com/terms">
              Terms of Service
            </a>{' '}
            apply.
          </div> */}
        </div>
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  openModal: (modalProps, modalType) => dispatch(openModal({ modalProps, modalType })),
});

export default connect(null, mapDispatchToProps)(AffiliateSignUpModal);
